import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import '../Box/index.js';
import { Text } from '../Box/BoxSystem.js';

const NewFeatureHighlightPopoverBody = ({ titleText, bodyText, }) => {
    return (jsxs(Fragment, { children: [jsx(Text, Object.assign({ fontSize: "E", fontWeight: "medium" }, { children: titleText })), jsx(Text, Object.assign({ mt: 2, textStyle: "copy.tertiary.standard.C" }, { children: bodyText }))] }));
};

export { NewFeatureHighlightPopoverBody };
